"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var condensed_job_event_filter_1 = require("./condensed-job-event.filter");
var camelcaseKeysDeep = require('camelcase-keys-deep');
var decamelizeKeysDeep = require('decamelize-keys-deep');
var CondensedJobEventFilterSerializer = /** @class */ (function () {
    function CondensedJobEventFilterSerializer() {
    }
    CondensedJobEventFilterSerializer.prototype.fromJson = function (json) {
        json = camelcaseKeysDeep(json);
        var jobEventFilter = new condensed_job_event_filter_1.CondensedJobEventFilter();
        if (!json) {
            return jobEventFilter;
        }
        jobEventFilter.id = json.id;
        jobEventFilter.name = json.name;
        return jobEventFilter;
    };
    CondensedJobEventFilterSerializer.prototype.toJson = function (jobEventFilter) {
        var json = {
            id: jobEventFilter.id,
            name: jobEventFilter.name
        };
        return decamelizeKeysDeep(json);
    };
    return CondensedJobEventFilterSerializer;
}());
exports.CondensedJobEventFilterSerializer = CondensedJobEventFilterSerializer;
